import { 
    yellow,
    red,
    blue,
    axisName,
    pageBg
} from './color'



export var topToBottom = function(a='20171031'){
  return {
    $axisIndex: [0, 1],
    $seriesIndex: 0,
    data: [
      {
        areaStyle: {
          normal: {
            fill: 'rgba(0,150,255,0.12)'
          }
        },
        points: [
          {
            x: 'top',
            y: 'left'
          },
          {
            xValue: a,
            y: 'right'
          }
        ]
      },
      {
        areaStyle: {
          normal: {
            fill: 'rgba(0,150,255,0.06)'
          }
        },
        points: [
          {
            xValue: a,
            y: 'left'
          },
          {
            x: 'bottom',
            y: 'right'
          }
        ]
      }
      // {
      //   areaStyle: {
      //     normal: {
      //       fill: 'rgba(253,67,50,0.1)'
      //     }
      //   },
      //   points: [
      //     {
      //       x: 'top',
      //       yValue: b
      //     },
      //     {
      //       x: 'bottom',
      //       y: 'right'
      //     }
      //   ]
      // }
    ]
  }
}


export var leftToRight = function(a=13.65, b=16.31){
  return {
    $axisIndex: [0, 1],
    $seriesIndex: 0,
    data: [
      {
        areaStyle: {
          normal: {
            fill: 'rgba(0,150,255,0.1)'
          }
        },
        points: [
          {
            x: 'top',
            y: 'left'
          },
          {
            x: 'bottom',
            yValue: a
          }
        ]
      },
      {
        areaStyle: {
          normal: {
            fill: 'rgba(209,184,15,0.1)'
          }
        },
        points: [
          {
            x: 'top',
            yValue: a
          },
          {
            x: 'bottom',
            yValue: b
          }
        ]
      },
      {
        areaStyle: {
          normal: {
            fill: 'rgba(253,67,50,0.1)'
          }
        },
        points: [
          {
            x: 'top',
            yValue: b
          },
          {
            x: 'bottom',
            y: 'right'
          }
        ]
      }
    ]
  }
}
